import { render, staticRenderFns } from "./editAdditionProduct.vue?vue&type=template&id=1dae47c3&scoped=true"
import script from "./editAdditionProduct.vue?vue&type=script&lang=js"
export * from "./editAdditionProduct.vue?vue&type=script&lang=js"
import style0 from "./editAdditionProduct.vue?vue&type=style&index=0&id=1dae47c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae47c3",
  null
  
)

export default component.exports